<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="list-row">
    <v-row @click="$store.commit('dialog_is_product',{toggle:true,index:currentIndex})">
      <v-col class="col-1">

      </v-col>
      <v-col>
        {{ (item.product?item.product.nickname:null) || item.product_code}}
      </v-col>
      <v-col class="col-2 text-right">
        @{{ number_format(item.price_init)}}
      </v-col>
      <v-col class="col-2 text-right">
        @{{ number_format(item.price_in_vat)}}
      </v-col>
      <v-col class="col-1 text-right">
        {{ item.quantity}}
      </v-col>
      <v-col class="col-2 text-right">
        {{ number_format(item.total_gross)}}
      </v-col>
      <v-col class="col-2 text-right">
        {{ number_format(item.total_net)}}
      </v-col>
    </v-row>
  </div>

</template>
<style lang="scss" scoped>

</style>

<script lang="ts">

  import {Component, Prop, Vue} from 'vue-property-decorator'
  import {Item} from '../../models/Item'

  import Helper from '../../services/Helper.js'

  @Component({
    components: {},
  })
  export default class ItemEditRow extends Vue {
    @Prop() item: Item
    @Prop() currentIndex: number

    number_format = Helper.number_format
  }

</script>
